import { cloneDeep } from 'lodash-es'
import { bodyTemperatureSetting } from './body-temperature/body-temperature-setting'

const createDefaultCheckTypoRules = () => ({
  body_temperature: cloneDeep(
    bodyTemperatureSetting.getBodyTemperatureEmrRules()
  ),
  heart_rate: {
    min: 40,
    max: 150
  },
  respiration_rate: {
    min: 5,
    max: 35
  },
  spo2: {
    min: 80,
    max: 100
  },
  bloodGlucose: {
    min: 20,
    max: 600
  },
  diastolicPressure: {
    min: 40,
    max: 130
  },
  systolicPressure: {
    min: 70,
    max: 220
  }
})

export const checkTypoRules = {
  ...createDefaultCheckTypoRules(),
  get: function (type: string) {
    if (type === 'body_temperature') {
      return this.body_temperature
    } else if (type === 'heart_rate') {
      return this.heart_rate
    } else if (type === 'respiration_rate') {
      return this.respiration_rate
    } else if (type === 'spo2') {
      return this.spo2
    } else if (type === 'diastolicPressure') {
      return this.diastolicPressure
    } else if (type === 'systolicPressure') {
      return this.systolicPressure
    } else if (type === 'bloodGlucose') {
      return this.bloodGlucose
    }
    {
      return {
        min: 0,
        max: 0
      }
    }
  },
  set: function ({
    body_temperature,
    heart_rate,
    respiration_rate,
    spo2,
    diastolicPressure,
    systolicPressure,
    bloodGlucose
  }: any) {
    if (body_temperature) {
      this.body_temperature = {
        min: body_temperature.min,
        max: body_temperature.max
      }
    }
    if (heart_rate) {
      this.heart_rate = {
        min: heart_rate.min,
        max: heart_rate.max
      }
    }
    if (respiration_rate) {
      this.respiration_rate = {
        min: respiration_rate.min,
        max: respiration_rate.max
      }
    }
    if (spo2) {
      this.spo2 = {
        min: spo2.min,
        max: spo2.max
      }
    }
    if (diastolicPressure) {
      this.diastolicPressure = {
        min: diastolicPressure.min,
        max: diastolicPressure.max
      }
    }
    if (systolicPressure) {
      this.systolicPressure = {
        min: systolicPressure.min,
        max: systolicPressure.max
      }
    }
    if (bloodGlucose) {
      this.bloodGlucose = {
        min: bloodGlucose.min,
        max: bloodGlucose.max
      }
    }
  },
  reset: function () {
    Object.assign(this, createDefaultCheckTypoRules())
  }
}
